// @flow
export const showButton = (button: HTMLElement) => {
  button.hidden = false;
};

export const hideButton = (button: HTMLElement) => {
  button.hidden = true;
};

export const setFetchingState = (button: HTMLElement) => {
  button.classList.add('simple-button--loading');
};

export const unsetFetchingState = (button: HTMLElement) => {
  button.classList.remove('simple-button--loading');
};
